<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->

<!--COURSE DETAIL-->
<ng-template [ngIf]="!isLoading">
  <section class="course-detail">
    <!--COURSE HEADER HERO-->
    <!--NOTE: Course model has a reference to the parent subscription id and parent subscription slug
    that only exists in memory and is not mapped in Docebo. This allows course to find and redirect back to parent subscription
    -->
    <app-hero-banner
      id="course-detail-{{ course?.slugName }}"
      [name]="
        course?.instructionType === instructionType.WEBINAR
          ? instructionType.WEBINAR
          : course?.instructionType === instructionType.QUICK_LEARNING
          ? instructionType.QUICK_LEARNING
          : course?.type !== instructionType.E_LEARNING.toLowerCase() ||
            course?.instructionType === instructionType.SELF_STUDY
          ? instructionType.COURSE
          : course?.instructionType === instructionType.CERTIFICATION_EXAM
          ? instructionType.CERTIFICATION_EXAM
          : instructionType.E_LEARNING
      "
      [title]="course?.name"
      [heroImageCss]="'course-hero'"
      [alignContentCss]="['hero-wrapper-auto', 'text-color-white']"
      [description]="course?.description"
      [showButton]="false">
      <!--NOTE: Inject custom content-->
      <!--NOTE: content is being binded by 'subHeader' in hero banner-->
      <div subHeader>
        <!--DURATION IN DAYS OR MINUTES-->
        <app-duration
          [showDuration]="course?.instructionType | showDurationByInstructionType"
          [duration]="
            course?.instructionType
              | formatDuration : course?.courseDuration : course?.courseDurationMins
          "
          [iconColor]="'white'"
          [iconSize]="'small'"
          [iconClass]="'flexbox'"
          [showIcon]="true">
        </app-duration>
        <!--END DURATION IN DAYS or MINUTES-->
      </div>
      <!--NOTE: content is being binded by 'content' in hero banner-->
      <div class="details-section margin-top-large" content>
        <!--MULTIPLE SUBSCRIPTIONS-->
        <!--HEADER CALL TO ACTION - HANDLE MULTIPLE SUBSCRIPTION CTA-->
        <!--NOTE: 'location' context passed so the nested courseButton template can generate a
        unique id for its app-route-button instance. Previously both the header and footer
        instances shared the exact same id, which caused the footer "Learn More" link to 404.-->
        <ng-template
          [ngTemplateOutlet]="handleSubscriptions"
          [ngTemplateOutletContext]="{ location: 'header' }"></ng-template>
        <!--END HEADER CALL TO ACTION - HANDLE MULTIPLE SUBSCRIPTION CTA-->
        <!--END MULTIPLE SUBSCRIPTIONS-->
        <!--AVAILABLE INSTRUCTION TYPES-->
        <!--NOTE: Instruction Types buttons will show for anything but elearning and Certification Exam-->
        <ng-container *ngIf="shouldShowInstructionTypes()">
          <div class="flexbox justify-content-end text-color-white margin-bottom-small">
            Available in the following instruction types
          </div>
          <ul class="flexbox justify-content-end">
            <!--INSTRUCTOR-LED BUTTON-->
            <!--NOTE: Classroom is legacy Instructor-Led (ILT)-->
            <!--NOTE: Instructor-Led (Virtual) is not current configured in Docebo. Pending change in 2022-->
            <ng-container
              *ngIf="
                course?.instructionType === instructionType.INSTRUCTOR_LED ||
                hasLearningType(instructionType.INSTRUCTOR_LED)
              ">
              <li class="margin-left-small">
                <!--NOTE: template created for hover state change-->
                <ng-container *ngIf="!toggleSwitch; then thenBlock; else elseBlock"> </ng-container>
                <ng-template #thenBlock>
                  
                    <a
                    id="course-detail-instructor-led-button-{{ course?.slugName }}"
                    attr.data-beyond-button-id="course-detail-instructor-led-button-{{
                      course?.slugName
                    }}"
                    [ngClass]="'btn-inverse'"
                    class="btn box"
                    (click)="
                      scrollIntoView(course?.instructionType); sendGoogleAnalytics('Course Detail', 'click', course?.slugName)
                    ">
                    <i class="card-icon red icon margin-right-small virtual small"> </i>
                    <span>{{ instructionType.INSTRUCTOR_LED }}</span>
                  </a>
                </ng-template>
                <ng-template #elseBlock>
                  
                    <a
                    id="course-detail-instructor-led-button-{{ course?.slugName }}"
                    attr.data-beyond-button-id="course-detail-instructor-led-button-{{
                      course?.slugName
                    }}"
                    [ngClass]="'btn-inverse-gray'"
                    class="btn box"
                    (click)="
                      loadRelatedCourse(instructionType.INSTRUCTOR_LED); onToggleChange();
                      scrollIntoView(course?.instructionType); sendGoogleAnalytics('Course Detail', 'click', course?.slugName)
                    ">
                    <i class="card-icon gray icon margin-right-small virtual small"> </i>
                    <span>{{ instructionType.INSTRUCTOR_LED }}</span>
                  </a>
                </ng-template>
              </li>
            </ng-container>
            <!--END INSTRUCTOR-LED BUTTON-->
            <!--TODO: Make these box buttons a common shared component-->
            <!--INSTRUCTOR-LED IN PERSON BUTTON-->
            <!--NOTE: Classroom is legacy Instructor-Led (ILT)-->
            <!--NOTE: Instructor-Led (Virtual) is not current configured in Docebo. Pending change in 2022-->
            <ng-container
              *ngIf="
                course?.instructionType === instructionType.INSTRUCTOR_LED_IN_PERSON ||
                hasLearningType(instructionType.INSTRUCTOR_LED_IN_PERSON)
              ">
              <li class="margin-left-small">
                
                  <a
                  id="course-detail-instructor-led-in-person-button-{{ course?.slugName }}"
                  attr.data-beyond-button-id="course-detail-instructor-led-in-person-button-{{
                    course?.slugName
                  }}" class="btn box btn-inverse" (click)="sendGoogleAnalytics('Course Detail',
                  'click', course?.slug)">
                  <i class="card-icon icon margin-right-small person red small"></i>
                  <span>{{ instructionType.INSTRUCTOR_LED_IN_PERSON }}</span>
                </a>
              </li>
            </ng-container>
            <!--INSTRUCTOR-LED IN PERSON BUTTON-->
            <!--NOTE: Classroom is legacy Instructor-Led (ILT)-->
            <!--NOTE: Instructor-Led (Virtual) is not current configured in Docebo. Pending change in 2022-->
            <ng-container
              *ngIf="
                course?.instructionType === instructionType.INSTRUCTOR_LED_VIRTUAL ||
                hasLearningType(instructionType.INSTRUCTOR_LED_VIRTUAL)
              ">
              <li class="margin-left-small">
                
                  <a
                  id="course-detail-instructor-led-virtual-button-{{ course?.slugName }}"
                  attr.data-beyond-button-id="course-detail-instructor-led-virtual-button-{{
                    course?.slugName
                  }}" class="btn box btn-inverse" (click)="sendGoogleAnalytics('Course Detail',
                  'click', course?.slugName)">
                  <i class="card-icon icon margin-right-small virtual red small"></i>
                  <span>{{ instructionType.INSTRUCTOR_LED_VIRTUAL }}</span>
                </a>
              </li>
            </ng-container>
            <!--END INSTRUCTOR-LED VIRTUAL BUTTON-->
            <!--SELF STUDY BUTTON-->
            <!--NOTE: Self Study shows for instruction type -->
            <ng-container
              *ngIf="
                course?.instructionType === instructionType.SELF_STUDY ||
                hasLearningType(instructionType.SELF_STUDY)
              ">
              <li class="margin-left-small">
                <!--NOTE: template created for hover state change-->
                <ng-container *ngIf="toggleSwitch; then thenBlock; else elseBlock"> </ng-container>
                <ng-template #thenBlock>
                  
                    <a
                    id="course-detail-self-study-button-{{ course?.slugName }}"
                    attr.data-beyond-button-id="course-detail-self-study-button-{{
                      course?.slugName
                    }}"
                    [ngClass]="'btn-inverse'"
                    class="btn box"
                    (click)="
                      scrollIntoView(course?.instructionType); sendGoogleAnalytics('Course Detail', 'click', course?.slugName)
                    ">
                    <i class="card-icon icon red margin-right-small self-study small"> </i>
                    <span>{{ instructionType.SELF_STUDY }}</span>
                  </a>
                </ng-template>
                <ng-template #elseBlock>
                  
                    <a
                    id="course-detail-self-study-button-{{ course?.slugName }}"
                    attr.data-beyond-button-id="course-detail-self-study-button-{{
                      course?.slugName
                    }}"
                    [ngClass]="'btn-inverse-gray'"
                    class="btn box"
                    (click)="
                      loadRelatedCourse(instructionType.SELF_STUDY); onToggleChange();
                      scrollIntoView(course?.instructionType); sendGoogleAnalytics('Course Detail', 'click', course?.slugName)
                    ">
                    <i class="card-icon icon gray margin-right-small self-study small"> </i>
                    <span>{{ instructionType.SELF_STUDY }}</span>
                  </a>
                </ng-template>
              </li>
            </ng-container>
            <!--END SELF STUDY BUTTON-->
          </ul>
        </ng-container>
        <!--END AVAILABLE INSTRUCTION TYPES BUTTON TABS-->
      </div>
    </app-hero-banner>
    <!--END COURSE HEADER HERO-->
    <!--COURSE DETAIL-->
    <div class="course-content">
      <div class="wrapper">
        <div [ngClass]="course?.instructionType | layoutColumn : 'column'">
          <!--LEFT ASIDE COLUMN-->
          <div class="left-aside-column">
            <div class="course-column" id="print-section">
              <p class="printer-instruction-type">
                {{
                  course?.instructionType === instructionType.QUICK_LEARNING
                    ? instructionType.QUICK_LEARNING
                    : course?.type !== instructionType.E_LEARNING.toLowerCase() ||
                      course?.instructionType === instructionType.SELF_STUDY
                    ? instructionType.COURSE
                    : instructionType.E_LEARNING
                }}
              </p>
              <h1 class="print-course-title">
                {{ course?.name }}
              </h1>
              <div class="instruction-type" [id]="course?.instructionType">
                <!--INSTRUCTION DETAILS-->
                <app-course-instruction-type
                  [instructionType]="course?.instructionType"
                  [courseDuration]="
                    course?.instructionType
                      | formatDuration : course?.courseDuration : course?.courseDurationMins
                  "
                  [printFlag]="true"
                  [durationFlag]="false"></app-course-instruction-type>
                <!--END INSTRUCTION DETAILS-->
                <hr class="course-details margin-top-large margin-bottom-large" />
              </div>

              <!--INSTRUCTION TYPE - SELF-STUDY DETAILS-->
              <ng-container *ngIf="course?.instructionType === instructionType.SELF_STUDY">
                <div class="course-section">
                  <h4 class="margin-bottom-small">Details</h4>
                  <!--NOTE: Genesys Cloud currently is using CloudShare hence the Remote Access detail. All other subscriptions will show old information.
                  All the other subscriptions will eventualy be on CloudShare. -->
                  <p
                    [innerHTML]="
                      primaryUserSubscriptionSlugName ===
                        subscriptionType.GENESYS_CLOUD_SUBSCRIPTION ||
                      primaryUserSubscriptionSlugName ===
                        subscriptionType.GENESYS_CLOUD_CX_SUBSCRIPTION
                        ? getInstructionsByName(instructionSteps.REMOTE_ACCESS_SELF_STUDY_DETAILS)
                        : (getInstructionsByName(instructionSteps.SELF_STUDY_DETAILS)
                          | safe : 'html')
                    "></p>
                </div>
                <hr class="course-details margin-top-large margin-bottom-large" />
              </ng-container>
              <!--END INSTRUCTION TYPE SELF-STUDY DETAILS-->

              <!--COURSE DESCRIPTION-->
              <p
                class="course-desc margin-top-small margin-bottom-small"
                [innerHTML]="course?.description | safe : 'html'"></p>
              <!--END COURSE DESCRIPTION-->

              <!--COURSE REQUIREMENTS-->
              <ng-container *ngIf="course?.courseVersionRequirement">
                <div class="course-section">
                  <hr class="margin-top-large margin-bottom-large" />
                  <h4 class="margin-bottom-small">Course Requirements</h4>
                  <div
                    class="block-content"
                    [innerHTML]="course.courseVersionRequirement | safe : 'html'"></div>
                </div>
              </ng-container>
              <!--END COURSE REQUIREMENTS-->

              <!--COURSE AUDIENCE-->
              <ng-container *ngIf="course?.targetAudience">
                <div class="course-section margin-top-small">
                  <hr class="margin-top-large margin-bottom-large" />
                  <h4 class="margin-bottom-small">Target Audience</h4>
                  <div
                    class="block-content"
                    [innerHTML]="course.targetAudience | safe : 'html'"></div>
                </div>
              </ng-container>
              <!--END COURSE AUDIENCE-->

              <!--COURSE PREREQUISITES SS-->
              <ng-container *ngIf="course?.prerequisitesSS">
                <div class="course-section margin-top-small">
                  <hr class="margin-top-large margin-bottom-large" />
                  <h4 class="margin-bottom-small">Course Prerequisites</h4>
                  <div
                    class="block-content"
                    [innerHTML]="course.prerequisitesSS | safe : 'html'"></div>
                </div>
              </ng-container>
              <!--END COURSE PREREQUISITES SS-->

              <!--COURSE OBJECTIVES-->
              <ng-container *ngIf="course?.objectives">
                <div class="course-section margin-top-small margin-bottom-large">
                  <hr class="margin-top-large margin-bottom-large" />
                  <h4 class="margin-bottom-small">Course Objectives</h4>
                  <div
                    class="block-content course-objective"
                    [innerHTML]="course.objectives | safe : 'html'"></div>
                </div>
              </ng-container>
              <!--END COURSE OBJECTIVES-->

              <!--COURSE OUTLINE ACCORDION-->
              <!--NOTE: This is just a static accordion showing course outline html from Docebo
                        has nothing to do with catalog search accordion but calls the shared accordion-->
              <app-accordion
                [entries]="courseAccordionData"
                [customAccordionContentCss]="'block-content'"></app-accordion>
              <!--END COURSE OUTLINE ACCORDION-->

              <!--COURSE SESSIONS-->
              <div class="course-sessions margin-top-large" id="session-wrapper">
                <!--INSTRUCTION DETAILS-->
                <div
                  class="margin-top-small"
                  *ngIf="course?.sessions?.length > 0 || course?.enrolledSession?.length > 0">
                  <app-course-instruction-type
                    [instructionType]="course?.instructionType"
                    [instructionTypeFlag]="true"
                    [courseDuration]="
                      course?.instructionType
                        | formatDuration : course?.courseDuration : course?.courseDurationMins
                    "
                    [printFlag]="false"
                    [durationFlag]="true">
                  </app-course-instruction-type>
                </div>
                <!--END INSTRUCTION DETAILS-->

                <ng-container *ngIf="showSessions">
                  <!--ENROLLED SESSIONS-->
                  <ng-container *ngIf="course?.enrolledSession?.length > 0">
                    <hr class="course-details margin-top-large margin-bottom-large" />
                    <app-sessions
                      [title]="'Enrolled Sessions'"
                      [currentUser]="currentUser"
                      (sendClick)="loadCourse(this.courseId, this.slug)"
                      [course]="course"
                      [sessions]="course.enrolledSession">
                    </app-sessions>
                  </ng-container>
                  <!--END ENROLLED SESSIONS-->

                  <!--UPCOMING SESSIONS-->
                  <ng-container *ngIf="upcomingSessions?.length > 0">
                    <hr class="course-details margin-top-large margin-bottom-large" />
                    <app-sessions
                      [title]="'Upcoming Sessions'"
                      [currentUser]="currentUser"
                      [course]="course"
                      (sendClick)="loadCourse(this.courseId, this.slug)"
                      [sessions]="upcomingSessions">
                    </app-sessions>
                  </ng-container>
                  <!--END UPCOMING SESSIONS-->

                  <!-- PAST SESSIONS -->
                  <ng-container *ngIf="course && course.sessions?.length > 0">
                    <ng-container *ngIf="pastSessions?.length > 0; else noPastSessions">
                      <hr class="course-details margin-top-large margin-bottom-large" />
                      <app-sessions
                        [title]="'Past Sessions'"
                        [currentUser]="currentUser"
                        [course]="course"
                        (sendClick)="loadCourse(courseId, slug)"
                        [sessions]="pastSessions">
                      </app-sessions>
                    </ng-container>
                  </ng-container>

                  <ng-template #noPastSessions>
                    <ng-container *ngIf="course">
                      <hr class="course-details" />
                      <div class="no-sessions-message">No previous enrolled sessions.</div>
                    </ng-container>
                  </ng-template>
                </ng-container>
                <!-- END PAST SESSIONS -->
              </div>
              <!--END COURSE SESSIONS-->

              <!--NOTE: If route button changes, then this should be the same as in the hero banner or card component.-->
              <!--FOOTER CALL TO ACTION - HANDLE MULTIPLE SUBSCRIPTION CTA-->
              <ng-container
                *ngIf="
                  (courseAccordionData && courseAccordionData.length === 0) ||
                  (course?.sessions && course.sessions.length > 0)
                ">
                <!--NOTE: Show horizontal rule if there is no course detail accordion data. The accordion by default has the last hr in the component.
                Only show this if the course accordion data is not present or if there is course sessions.-->
                <hr class="course-details margin-top-large margin-bottom-large" />
              </ng-container>
              <!--NOTE: 'location' context passed so the nested courseButton template can generate a
              unique id for its app-route-button instance. Previously both the header and footer
              instances shared the exact same id, which caused the footer "Learn More" link to 404.-->
              <ng-template
                [ngTemplateOutlet]="handleSubscriptions"
                [ngTemplateOutletContext]="{ location: 'footer' }"></ng-template>
              <!--END FOOTER CALL TO ACTION - HANDLE MULTIPLE SUBSCRIPTION CTA-->
            </div>
          </div>
          <!--END LEFT ASIDE COLUMN-->

          <!--EXAM SCHEDULE INSTRUCTIONS-->
          <aside class="right-aside-column">
            <!--COMBINE EXAM AND SELFSTUDY INSTRUCTION LIST-->
            <app-instructions-list
              [shortTitle]="
                course?.instructionType === instructionType.CERTIFICATION_EXAM
                  ? 'How to Schedule Your Exam'
                  : ''
              "
              [icon]="
                course?.instructionType === instructionType.CERTIFICATION_EXAM
                  ? 'calendar'
                  : 'documentation'
              "
              [showInstructions]="course?.instructionType === instructionType.CERTIFICATION_EXAM"
              [instructionContentClass]="'instructions-header'"
              [toggleExpandCollapse]="true"
              [steps]="
                course?.instructionType === instructionType.CERTIFICATION_EXAM
                  ? getInstructionsByName(instructionSteps.CERTIFICATION_EXAM_STEPS)
                  : primaryUserSubscriptionSlugName ===
                      subscriptionType.GENESYS_CLOUD_SUBSCRIPTION ||
                    primaryUserSubscriptionSlugName ===
                      subscriptionType.GENESYS_CLOUD_CX_SUBSCRIPTION
                  ? getInstructionsByName(instructionSteps.REMOTE_ACCESS_SELF_STUDY_STEPS)
                  : getInstructionsByName(instructionSteps.SELF_STUDY_STEPS)
              ">
            </app-instructions-list>
            <!--END COMBINE EXAM AND SELFSTUDY INSTRUCTION LIST-->
          </aside>
          <!--END EXAM SCHEDULE INSTRUCTIONS-->
        </div>
      </div>
    </div>
    <!--END COURSE DETAIL-->
    <!--SUBSCRIPTION LIST-->
    <!--NOTE: Shared subscription list is also on the home page-->
    <ng-container *ngIf="subscriptionTilesNew; then thenBlock; else elseBlock"></ng-container>
    <ng-template #thenBlock>
      <app-subscription-tiles></app-subscription-tiles>
    </ng-template>
    <ng-template #elseBlock>
      <app-legacy-subscription-tiles></app-legacy-subscription-tiles>
      <!--<app-subscription-list [isLightMode]="false"></app-subscription-list>-->
    </ng-template>
    <!--END SUBSCRIPTION LIST-->
  </section>
  <!--END COURSE DETAIL-->
</ng-template>

<!--REQUEST A QUOTE (VOUCHER) FORM-->
<app-modal-dialog [containerID]="'requestForm'" [modalMaxWidth]="'modal-max-width-medium'">
  <div #modalContainer>
    <app-request-form [formHeading]="'Request a Quote'"></app-request-form>
  </div>
</app-modal-dialog>
<!--END REQUEST A QUOTE (VOUCHER) FORM-->

<!--NOTE: Reuse the course button with the template outline to handle header and footer call to call-->
<!--COURSE CALL TO ACTION-->
<!--NOTE: 'location' context (header/footer) is forwarded in here from #handleSubscriptions below,
and used to make each app-route-button id unique across the two render locations.-->
<ng-template #courseButton let-location="location">
  <!--NOTE: Handle case for auto-enroll for eLearning courses (including Self-Study) and Certificate Exams (assuming user has the correct subscription to enroll). This changes Enroll to Start without redirecting page.
    Route Type remains INTERNAL but no route is passed if you are on the same page. Else everything else is treated as an EXTERNAL route type with a
    valid route-->

  <div *ngIf="shouldShowStandardCTA(); then thenBlock; else redirectRoute"></div>

  <ng-template #thenBlock>
    <div class="exam-dual-cta">
      <app-route-button
        id="course-detail-{{ location }}-{{ course?.slugName }}"
        [customButtonCss]="'btn-primary larger-btn'"
        [showButton]="
          course?.instructionType === instructionType.E_LEARNING ||
          course?.instructionType === instructionType.QUICK_LEARNING ||
          (course?.instructionType === instructionType.SELF_STUDY &&
            isValidSubscription(
              course?.relatedSubscriptionIds,
              course?.subscriptionId,
              currentUser
            )) ||
          course?.instructionType === instructionType.CERTIFICATION_EXAM
        "
        [routeType]="
          currentUser
            | courseDetailTypeCallToActions
              : course?.subscriptionId
              : course?.instructionType
              : course?.relatedSubscriptionIds
              : course?.id
              : course?.isFreeCourse
              : true
            | routeTypesByCallToActions
              : course?.instructionType
              : course?.instructionType !== instructionType.QUICK_LEARNING
        "
        secondaryLinkRoute="{{ 'subscription/' + primaryUserSubscriptionSlugName }}"
        [buttonRoute]="
          currentUser
            | courseDetailRoute
              : course?.instructionType
              : course?.slugName
              : course?.subscriptionId
              : course?.relatedSubscriptionIds
              : course?.id
              : course?.isFreeCourse
              : 'course'
              : course?.subscriptionSlugName
              : course?.code
        "
        [showErrorMessage]="true"
        [errorMessage]="enrollMessage ? enrollMessage?.message : ''"
        (buttonClick)="
          sendGoogleAnalytics('Course Detail', 'click', $event);
          loadEnrollELearning($event, course?.instructionType, course?.id);
          loadEnrollCertification($event, course?.instructionType, course?.id, course?.name)
        "
        [actionLabel]="
          currentUser
            | courseDetailTypeCallToActions
              : course?.subscriptionId
              : course?.instructionType
              : course?.relatedSubscriptionIds
              : course?.id
              : course?.isFreeCourse
              : true
        ">
      </app-route-button>

      <!-- <app-route-button
        *ngIf="showStudyGuideForCertExam"
        id="course-detail-study-guide-{{ course?.slugName }}"
        [customButtonCss]="'btn-primary larger-btn'"
        [showButton]="true"
        [routeType]="
          cardTypeCallToActions.VIEW_STUDY_GUIDE
            | routeTypesByCallToActions : course?.instructionType : true
        "
        [buttonRoute]="
          currentUser
            | courseDetailRoute
              : course?.instructionType
              : course?.slugName
              : course?.subscriptionId
              : course?.relatedSubscriptionIds
              : course?.id
              : course?.isFreeCourse
              : 'study-guide'
              : course?.subscriptionSlugName
              : course?.code
        "
        (buttonClick)="sendGoogleAnalytics('Course Detail', 'click', 'View Study Guide')"
        [actionLabel]="enrollmentMessage?.VIEW_STUDY_GUIDE || 'View Study Guide'">
      </app-route-button> -->
    </div>
  </ng-template>

  <ng-template #redirectRoute>
    <!--TODO: Not sure if this gets called or used. Will need to revisit and test to see if we can remove this.-->
    <app-route-button
      id="course-detail-{{ location }}-{{ course?.slugName }}"
      [routeType]="
        currentUser
          | courseDetailTypeCallToActions
            : course?.subscriptionId
            : course?.instructionType
            : course?.relatedSubscriptionIds
            : course?.id
            : course?.isFreeCourse
          | routeTypesByCallToActions : course?.instructionType : true
      "
      [route]="
        currentUser
          | courseDetailRoute
            : course?.instructionType
            : course?.slugName
            : course?.subscriptionId
            : course?.relatedSubscriptionIds
            : course?.id
            : course?.isFreeCourse
            : 'course'
            : course?.subscriptionSlugName
            : course?.code
      "
      secondaryLinkRoute="{{ 'subscription/' + primaryUserSubscriptionSlugName }}"
      [buttonRoute]="
        currentUser
          | courseDetailRoute
            : course?.instructionType
            : course?.slugName
            : course?.subscriptionId
            : course?.relatedSubscriptionIds
            : course?.id
            : course?.isFreeCourse
            : 'course'
            : course?.subscriptionSlugName
            : course?.code
      "
      (buttonClick)="
        sendGoogleAnalytics('Course Detail', 'click', $event);
        loadEnrollELearning($event, course?.instructionType, course?.id)
      "
      [actionLabel]="
        currentUser
          | courseDetailTypeCallToActions
            : course?.subscriptionId
            : course?.instructionType
            : course?.relatedSubscriptionIds
            : course?.id
            : course?.isFreeCourse
            : true
      ">
    </app-route-button>
  </ng-template>
</ng-template>
<!--END COURSE CALL TO ACTION-->

<!--HANDLE SUBSCRIPTIONS TEMPLATE-->
<!--NOTE: 'location' context (header/footer) is received from each ngTemplateOutlet call site above,
and forwarded down into #courseButton so the rendered app-route-button ids stay unique.-->
<ng-template #handleSubscriptions let-location="location">
  <ng-container *ngIf="isUserDataLoading">
    <app-loading-spinner></app-loading-spinner>
  </ng-container>

  <ng-container *ngIf="!isUserDataLoading">
    <!--  Visitor NOT signed in -->
    <ng-container *ngIf="!currentUser">
      <!-- BYK webinar sign‑in prompt -->
      <p *ngIf="isBYKWebinar(course); else notWebinar">
        Please
        <a routerLink="/login" class="cursor gen-primary-link--accesible with-underline">sign in</a>
        to your account to view this webinar.
      </p>

      <!-- Any other course  original subscription notice -->
      <ng-template #notWebinar>
        <p>
          An active
          <a class="cursor gen-primary-link--accesible with-underline" href="/products">
            Education learning subscription
          </a>
          is required to access this course.
        </p>
      </ng-template>
    </ng-container>

    <!-- ▸ Visitor IS signed in but lacks a valid subscription -->
    <ng-container
      *ngIf="
        currentUser &&
        !course?.isFreeCourse &&
        !isValidSubscription(course?.relatedSubscriptionIds, course?.subscriptionId, currentUser) &&
        !isDigitalSubscriptionEnrolled(courseId, currentUser)
      ">
      <p>
        An active
        <a class="cursor gen-primary-link--accesible with-underline" href="/products">
          Education learning subscription
        </a>
        is required to access this course.
      </p>
    </ng-container>

    <!-- ▸ CTA button -->
    <div class="margin-bottom-small margin-top-small">
      <ng-template
        [ngTemplateOutlet]="courseButton"
        [ngTemplateOutletContext]="{ location: location }"></ng-template>
    </div>
  </ng-container>
</ng-template>
<!--END HANDLE SUBSCRIPTIONS TEMPLATE-->
```
